import { FC } from 'react';
import { useNavigate, useLocation } from 'react-router';

import { Box, Button } from '@qwealth/qcore';

import { useAppSelector } from 'data/store';
import { selectClientComplianceReview } from 'data/selectors/compliance';
import { ClientComplianceReview } from 'data/models/Compliance';
import ReviewItem from '../Reviews/ReviewItem';
import Checklist from './Checklist';
import BackButton from '../../common/BackButton';
import { complianceRoute } from 'data/refData/compliance';

interface ComplianceChecklistCardProps {
  clickBack: () => void;
}

const ComplianceChecklistCard: FC<ComplianceChecklistCardProps> = ({ clickBack }): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMessagesSection = location.search.includes('section=Messages');
  const contact: ClientComplianceReview | undefined = useAppSelector(selectClientComplianceReview);

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="50%"
      maxHeight="100vh"
      backgroundColor="white"
      padding="large"
      boxShadow="layout"
      overflowY="hidden"
    >
      <Box marginBottom="large" display="flex" flexDirection="column" gap="default">
        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
          <BackButton clickBack={clickBack} hasIcon={true} btnText="Back" />
          {!isMessagesSection && (
            <Button onClick={() => navigate(`/${complianceRoute.path}/contact/${contact?.QID}?section=Messages`)}>View Messages</Button>
          )}
        </Box>
        <Box height="1px" backgroundColor="gray.0" />
      </Box>
      <Box backgroundColor="gray.4">
        <ReviewItem contact={contact} />
        <Box overflowY="auto">
          <Checklist />
        </Box>
      </Box>
    </Box>
  );
};

export default ComplianceChecklistCard;
